/**
 * AudioData
 * @property {number} FlvSoundFormat
 */
export const FlvSoundFormat = {
  MP3: 2,
  G711A: 7, // G.711 A-law logarithmic PCM
  G711M: 8, // G.711 mu-law logarithmic PCM
  AAC: 10, // AAC
  OPUS: 13
}

